import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface RoleBasedRedirectProps {
  children: React.ReactNode;
}

const RoleBasedRedirect: React.FC<RoleBasedRedirectProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  // Show loading while user data is being fetched
  if (isLoading || !user) {
    return <>{children}</>;
  }

  // If user is a viewer, redirect to my-insights (fallback for all viewer access)
  if (user.role?.name === 'viewer') {
    return <Navigate to="/my-insights" replace />;
  }

  // Sales practice viewers land on the solution story page by default
  if (user.role?.name === 'sales_practice_viewer') {
    return <Navigate to="/solution-story" replace />;
  }

  // For all other roles (admin, manager, etc.), show the children (dashboard)
  return <>{children}</>;
};

export default RoleBasedRedirect;
